import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router-dom'

const PrivateRouteComponent = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) =>{
    return (
      rest.authenticated == true
        ? <Component {...props} />
        : <Redirect to={{
            pathname: '/login',
            state: { from: props.location }
          }} />
    )
  }
} />
)

function mapStateToProps(state) {
	return { authenticated: state.auth.authenticated};
}

export default withRouter(connect(mapStateToProps)(PrivateRouteComponent));

